import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelectedClient } from '../context/SelectedClientContext';
import clientService from '../services/clientService';

const DuplicateSourceBanner = ({ duplicateSource, emailId }) => {
    const navigate = useNavigate();
    const { setSelectedClient } = useSelectedClient();
    const [isLoading, setIsLoading] = React.useState(false);

    const handleClick = async () => {
        if (!duplicateSource) return;

        setIsLoading(true);
        try {
            // Fetch all clients
            const allClients = await clientService.getAllClients();

            // Find client by name (case-insensitive match)
            const matchingClient = allClients.find(client =>
                client.name.toLowerCase() === duplicateSource.toLowerCase()
            );

            if (matchingClient) {
                // Update context (triggers data fetch in Member.js)
                setSelectedClient(matchingClient.id);

                // Navigate to members page with emails/tasks view
                navigate('/members', { state: { viewType: 'emails' } });
            } else {
                alert(`Client "${duplicateSource}" not found`);
            }
        } catch (error) {
            console.error('Error finding client:', error);
            alert('Error navigating to client');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            className={`duplicate-source-banner ${isLoading ? 'loading' : ''}`}
            onClick={handleClick}
            title={`Click to view all emails/tasks from ${duplicateSource}`}
        >
            <div className="duplicate-banner-icon">
                {isLoading ? '⏳' : '📋'}
            </div>
            <div className="duplicate-banner-content">
                <div className="duplicate-banner-title">
                    {isLoading ? 'Loading...' : 'Duplicate Invoice'}
                </div>
                <div className="duplicate-banner-text">
                    {!isLoading && (
                        <>
                            From <strong>{duplicateSource}</strong> - Click to view original
                        </>
                    )}
                </div>
            </div>
            {emailId && !isLoading && (
                <a
                    href={`/email/${emailId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="duplicate-banner-link"
                >
                    View Email
                </a>
            )}
        </div>
    );
};

export default DuplicateSourceBanner;
